export default "__VITE_PUBLIC_ASSET__e7d939d1__"